export default function ArqAbout() {
  return (
    <section id="about" className="bg-arq-bg py-20 md:py-[120px] px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="arq-label mb-6">Who We Are</div>
        <h2
          className="font-display font-semibold text-arq-text mb-10 max-w-[960px]"
          style={{ fontSize: "clamp(28px, 4vw, 40px)", lineHeight: 1.2 }}
        >
          Operational AI Security for Regulated and High-Stakes Organizations.
        </h2>

        <div className="grid md:grid-cols-5 gap-12">
          <div className="md:col-span-3 space-y-5 text-arq-muted text-[17px] leading-[1.75]">
            <p>
              ArqeraAI is an Operational AI Security firm for regulated and high-stakes
              organizations deploying AI across business-critical systems, applications, agents,
              and workflows.
            </p>
            <p>
              We operate at the intersection of AI security, application security, privacy
              engineering, and practical remediation.
            </p>
            <p>
              Our work is designed for environments where AI failure is not merely technical. It
              can affect revenue, customer trust, regulatory exposure, cyber insurance, enterprise
              sales, and executive confidence.
            </p>
            <p className="text-arq-text">We are practitioner-led and evidence-driven.</p>
            <p>
              We do not sell generic AI transformation. We do not only document gaps. We do not
              write reports and walk away.
            </p>
            <p className="text-arq-text/95 font-medium italic">
              We find what is exposed, fix what matters, and prove what is secure.
            </p>
          </div>

          <div className="md:col-span-2 space-y-5">
            <div className="arq-card p-8">
              <div className="font-display text-[28px] font-bold text-arq-text mb-2">10+ Years</div>
              <div className="text-arq-muted text-[14px] leading-[1.5]">
                Application security across enterprise and regulated environments
              </div>
            </div>
            <div className="arq-card p-8">
              <div className="font-display text-[28px] font-bold text-arq-text mb-2">Full Lifecycle</div>
              <div className="text-arq-muted text-[14px] leading-[1.5]">
                AI security · AppSec · Privacy engineering · Remediation · Validation · Evidence
              </div>
            </div>
            <div className="arq-card p-8">
              <div className="font-display text-[28px] font-bold text-arq-text mb-2">CISSP · AWS · Azure</div>
              <div className="text-arq-muted text-[14px] leading-[1.5]">
                Engineering-led practitioners with certifications across cloud and security
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
